import React from 'react';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { useIntl } from 'react-intl';

const CustomInput = ({
  type,
  placeholder,
  name,
  value,
  label,
  error,
  register,
  required,
  iconClass,
  change = () => {},
  onlyNumber,
  useNumberFormat,
  numberFormatParams = {},
  control,
  rules,
  customClass,
  customClassLabel = '',
  showErrorMessage = true,
  classError,
  disabled = false,
  readOnly = false,
}) => {
  const defaultValue = value || '';
  const inputType = type || 'text';
  const translate = useIntl();
  const changeError = (errorValid) => {
    switch (errorValid.type) {
      case 'required':
        return translate.formatMessage({ id: 'acc.field-required' });
      case 'pattern':
        return translate.formatMessage({ id: 'acc.email-required' });
      case 'parts':
        return translate.formatMessage({ id: 'acc.impossible-required' });
      case 'alreadyExisting':
        return translate.formatMessage({ id: 'acc.impossible-required' });
      case 'maxLength':
      case 'max':
        return translate.formatMessage({ id: 'acc.long-required' });
      case 'minLength':
      case 'min':
        return translate.formatMessage({ id: 'acc.long-required' });
      case 'positive':
      case 'moreThan':
      case 'lessThan':
      case 'leadingZeros':
        return errorValid.message;
      default:
        return '';
    }
  };
  const onNumberOnlyChange = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp('[0-9]').test(keyValue);
    if (!isValid) {
      event.preventDefault();
    }
  };

  const customLabelClass = `${required ? 'required' : ''} input__label ${customClassLabel}`;
  const cssImage = `def ${iconClass}`;
  const classInput = `${error ? `error ${classError}` : ''}`;
  return (
    <div className="input">
      {label && <label className={customLabelClass}>{label}</label>}
      {iconClass && <i className={cssImage} />}
      {useNumberFormat ? (
        <Controller
          control={control}
          as={NumberFormat}
          rules={rules}
          name={name}
          {...numberFormatParams}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onValueChange={change}
          disabled={disabled}
          readOnly={readOnly}
          className={`${classInput} ${customClass || ''}`}
        />
      ) : (
        <input
          type={inputType}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          readOnly={readOnly}
          defaultValue={defaultValue}
          ref={register}
          className={`${classInput} ${customClass || ''}`}
          onKeyPress={onlyNumber ? onNumberOnlyChange : () => {}}
          onChange={change}
          onWheel={(ev) => ev.target.blur()}
        />
      )}
      {error && showErrorMessage && <div className="input__error">{changeError(error)}</div>}
    </div>
  );
};

export default CustomInput;
